import React from 'react';
import { Container, Grid, Box, CssBaseline } from '@mui/material';
import { Resources } from '../../../components/resources/resources';
import { TeamList } from '../listTeams/teamList.smart';
import { CreateIncident } from './components/createIncident.smart';
import { IncidentHeader } from '../../../components/incidentHeader/incidentHeader.smart';
import { OpenIncidentsList } from '../../../guardianApp/components/openIncidentsList/openIncidentsList.smart';

export const Home = () => {
  return (
    <Container>
      <CssBaseline />
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <IncidentHeader />
          {/* <OpenIncidentsList /> */}
          {/* <HomePageNotifications /> uncomment and test this if/when guardians can make conneqt requests */}
          <CreateIncident />
          <Box sx={{ ml: -2 }}>
            <TeamList size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2, p: 2 }}>
          <section id="resources">
            <Resources />
          </section>
        </Grid>
      </Grid>
    </Container>
  );
};
